import PageErrorIcon from "../assets/svg/page-error-icon";
const Page500 = () => {
  return (
    <div className="polymer-error-page-container">
      <div className="polymer-error-page-content-container polymer-error-page-content-container__500">
        <PageErrorIcon />
        <div>
          <h2>We’ll be back soon!</h2>
          <p style={{ marginBottom: 0 }}>
            There was an issue loading the web page as we are currently
            experiencing high traffic volume. Please try again later.
          </p>
          <p>Thank you for your patience.</p>
        </div>
      </div>
    </div>
  );
};

export default Page500;
